var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _rect, _path286;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCarFrontParked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 128,
    viewBox: "0 0 122 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2357 49.7831L46.4716 50.3962",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4716 50.3964L31.8018 52.0945",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8018 52.0944L28.9244 53.0377",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9245 53.0376L26.5188 54.9245",
    stroke: "black",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5188 54.9244L20.1509 69.2168",
    stroke: "black",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1509 69.217L19.8207 72.1888",
    stroke: "black",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8207 72.1887L20.0566 72.7075",
    stroke: "black",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0566 72.7075L20.5754 73.0377",
    stroke: "black",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5754 73.0379L26.6132 72.2831",
    stroke: "black",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6132 72.283L43.9244 70.6793",
    stroke: "black",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9244 70.6793L61.2357 70.1133",
    stroke: "black",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2357 70.1133L78.5941 70.6793",
    stroke: "black",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5941 70.6793L95.8582 72.283",
    stroke: "black",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8582 72.2831L101.943 73.0379",
    stroke: "black",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.943 73.0377L102.415 72.7075",
    stroke: "black",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M102.415 72.7075L102.651 72.1887",
    stroke: "black",
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M102.651 72.1888L102.32 69.217",
    stroke: "black",
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M102.32 69.2168L95.9526 54.9244",
    stroke: "black",
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9526 54.9245L93.5469 53.0376",
    stroke: "black",
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5469 53.0377L90.6696 52.0944",
    stroke: "black",
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6696 52.0945L75.9998 50.3964",
    stroke: "black",
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9998 50.3962L61.2357 49.7831",
    stroke: "black",
    strokeWidth: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1509 75.3962L10.2453 75.349",
    stroke: "black",
    strokeWidth: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2453 75.3492L12.2264 74.0756",
    stroke: "black",
    strokeWidth: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2264 74.0755L13.3585 72.0471",
    stroke: "black",
    strokeWidth: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6604 78.5096L13.9717 76.4341",
    stroke: "black",
    strokeWidth: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8299 74.8304L86.4243 72.8492",
    stroke: "black",
    strokeWidth: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4243 72.8491L73.83 71.7641",
    stroke: "black",
    strokeWidth: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73.83 71.7642L61.2357 71.6227",
    stroke: "black",
    strokeWidth: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2357 71.6227L48.6414 71.7642",
    stroke: "black",
    strokeWidth: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6414 71.7641L36.0942 72.8491",
    stroke: "black",
    strokeWidth: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0942 72.8492L23.6414 74.8304",
    stroke: "black",
    strokeWidth: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8773 72.0471L44.8678 74.4528",
    stroke: "black",
    strokeWidth: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8678 74.4528L45.4338 83.2264",
    stroke: "black",
    strokeWidth: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4338 83.2264L45.8112 73.651",
    stroke: "black",
    strokeWidth: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8112 73.651H61.2357",
    stroke: "black",
    strokeWidth: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2357 73.651H76.6602",
    stroke: "black",
    strokeWidth: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6602 73.651L77.0847 83.2264",
    stroke: "black",
    strokeWidth: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0847 83.2264L77.6507 74.4528",
    stroke: "black",
    strokeWidth: 0.5
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6507 74.4528L78.5941 72.0471",
    stroke: "black",
    strokeWidth: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M112.368 75.3962L112.226 75.349",
    stroke: "black",
    strokeWidth: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M112.226 75.3492L110.292 74.0756",
    stroke: "black",
    strokeWidth: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M110.292 74.0755L109.113 72.0471",
    stroke: "black",
    strokeWidth: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M110.858 78.5096L108.5 76.4341",
    stroke: "black",
    strokeWidth: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M24.066 117.66H23.6414",
    stroke: "black",
    strokeWidth: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6414 117.66L16.849 116.434",
    stroke: "black",
    strokeWidth: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M16.849 116.434L13.6415 114.83",
    stroke: "black",
    strokeWidth: 0.5
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6415 114.83L11.2358 112.141",
    stroke: "black",
    strokeWidth: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2358 112.141L9.91507 108.792",
    stroke: "black",
    strokeWidth: 0.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91509 108.792L9.86792 108.651",
    stroke: "black",
    strokeWidth: 0.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8396 115.962L19.0188 116.387",
    stroke: "black",
    strokeWidth: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0189 116.387L19.8679 116.198",
    stroke: "black",
    strokeWidth: 0.5
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8679 116.198L20.4339 115.585",
    stroke: "black",
    strokeWidth: 0.5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M20.434 115.585L20.5755 114.736",
    stroke: "black",
    strokeWidth: 0.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5754 114.736L20.1981 113.981",
    stroke: "black",
    strokeWidth: 0.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M20.198 113.981L19.2075 113.368",
    stroke: "black",
    strokeWidth: 0.5
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2075 113.368L17.6981 113.321",
    stroke: "black",
    strokeWidth: 0.5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6981 113.321L16.283 113.792",
    stroke: "black",
    strokeWidth: 0.5
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16.283 113.792L15.9528 114.217",
    stroke: "black",
    strokeWidth: 0.5
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9528 114.217V114.736",
    stroke: "black",
    strokeWidth: 0.5
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9528 114.736L16.283 115.16",
    stroke: "black",
    strokeWidth: 0.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M16.283 115.16L17.8396 115.962",
    stroke: "black",
    strokeWidth: 0.5
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9717 98.6508L13.1227 100.538",
    stroke: "black",
    strokeWidth: 0.5
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1227 100.538L13.2642 102.613",
    stroke: "black",
    strokeWidth: 0.5
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2641 102.613L14.3019 104.358",
    stroke: "black",
    strokeWidth: 0.5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3019 104.358H36.566",
    stroke: "black",
    strokeWidth: 0.5
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M36.566 104.358L38.1697 103.132",
    stroke: "black",
    strokeWidth: 0.5
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1697 103.132L38.4527 101.151",
    stroke: "black",
    strokeWidth: 0.5
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4528 101.151L37.7452 99.6884",
    stroke: "black",
    strokeWidth: 0.5
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7452 99.6886L36.566 98.6508",
    stroke: "black",
    strokeWidth: 0.5
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5659 98.6508H13.9716",
    stroke: "black",
    strokeWidth: 0.5
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9811 108.651H9.86792",
    stroke: "black",
    strokeWidth: 0.5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4997 111.34L94.5375 108.274",
    stroke: "black",
    strokeWidth: 0.5
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5375 108.273L94.4432 107.377",
    stroke: "black",
    strokeWidth: 0.5
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4431 107.377L93.9242 106.67",
    stroke: "black",
    strokeWidth: 0.5
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9243 106.67L92.5092 105.726",
    stroke: "black",
    strokeWidth: 0.5
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5091 105.726L90.8582 105.302",
    stroke: "black",
    strokeWidth: 0.5
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8582 105.302H31.6131",
    stroke: "black",
    strokeWidth: 0.5
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6132 105.302L30.0094 105.726",
    stroke: "black",
    strokeWidth: 0.5
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0094 105.726L28.5943 106.67",
    stroke: "black",
    strokeWidth: 0.5
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5943 106.67L28.0754 107.377",
    stroke: "black",
    strokeWidth: 0.5
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0754 107.377L27.9339 108.273",
    stroke: "black",
    strokeWidth: 0.5
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9339 108.274L28.9716 111.34",
    stroke: "black",
    strokeWidth: 0.5
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9716 111.339L30.6226 112.613",
    stroke: "black",
    strokeWidth: 0.5
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6226 112.613L33.6415 112.99",
    stroke: "black",
    strokeWidth: 0.5
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6414 112.991H88.8771",
    stroke: "black",
    strokeWidth: 0.5
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8771 112.99L91.8488 112.613",
    stroke: "black",
    strokeWidth: 0.5
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4054 117.66H98.8771",
    stroke: "black",
    strokeWidth: 0.5
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8771 117.66L105.622 116.434",
    stroke: "black",
    strokeWidth: 0.5
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M105.622 116.434L108.83 114.83",
    stroke: "black",
    strokeWidth: 0.5
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M108.83 114.83L111.283 112.141",
    stroke: "black",
    strokeWidth: 0.5
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M111.283 112.141L112.556 108.792",
    stroke: "black",
    strokeWidth: 0.5
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M112.556 108.792L112.603 108.651",
    stroke: "black",
    strokeWidth: 0.5
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8488 112.613C92.5347 112.401 93.121 111.949 93.4997 111.339",
    stroke: "black",
    strokeWidth: 0.5
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M104.632 115.962L103.5 116.387",
    stroke: "black",
    strokeWidth: 0.5
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M103.5 116.387L102.651 116.198",
    stroke: "black",
    strokeWidth: 0.5
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M102.651 116.198L102.037 115.585",
    stroke: "black",
    strokeWidth: 0.5
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M102.037 115.585L101.896 114.736",
    stroke: "black",
    strokeWidth: 0.5
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M101.896 114.736L102.273 113.981",
    stroke: "black",
    strokeWidth: 0.5
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M102.273 113.981L103.264 113.368",
    stroke: "black",
    strokeWidth: 0.5
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M103.264 113.368L104.773 113.321",
    stroke: "black",
    strokeWidth: 0.5
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M104.773 113.321L106.188 113.792",
    stroke: "black",
    strokeWidth: 0.5
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M106.188 113.792L106.519 114.217",
    stroke: "black",
    strokeWidth: 0.5
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M106.519 114.217L106.566 114.736",
    stroke: "black",
    strokeWidth: 0.5
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M106.566 114.736L106.236 115.16",
    stroke: "black",
    strokeWidth: 0.5
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M106.236 115.16L104.632 115.962",
    stroke: "black",
    strokeWidth: 0.5
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1129 110.066H28.3584",
    stroke: "black",
    strokeWidth: 0.5
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5375 108.415H27.9339",
    stroke: "black",
    strokeWidth: 0.5
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7641 91.1038H86.7073",
    stroke: "black",
    strokeWidth: 0.5
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0283 98.6508L22.0377 101.434",
    stroke: "black",
    strokeWidth: 0.5
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0377 101.434V104.358",
    stroke: "black",
    strokeWidth: 0.5
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4811 104.358L36.4245 103.132",
    stroke: "black",
    strokeWidth: 0.5
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4245 103.132L36.8018 101.575",
    stroke: "black",
    strokeWidth: 0.5
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8018 101.575L36.4716 99.9245",
    stroke: "black",
    strokeWidth: 0.5
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4716 99.9243L35.2924 98.6508",
    stroke: "black",
    strokeWidth: 0.5
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9054 98.6508H108.5",
    stroke: "black",
    strokeWidth: 0.5
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 98.6508L109.349 100.538",
    stroke: "black",
    strokeWidth: 0.5
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M109.349 100.538L109.254 102.613",
    stroke: "black",
    strokeWidth: 0.5
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M109.254 102.613L108.169 104.358",
    stroke: "black",
    strokeWidth: 0.5
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M108.17 104.358H85.9526",
    stroke: "black",
    strokeWidth: 0.5
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9526 104.358L84.3016 103.132",
    stroke: "black",
    strokeWidth: 0.5
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3017 103.132L84.0186 101.151",
    stroke: "black",
    strokeWidth: 0.5
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0186 101.151L84.7262 99.6884",
    stroke: "black",
    strokeWidth: 0.5
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7262 99.6886L85.9054 98.6508",
    stroke: "black",
    strokeWidth: 0.5
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M87.179 98.6508L86.047 99.9243",
    stroke: "black",
    strokeWidth: 0.5
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0469 99.9245L85.6695 101.575",
    stroke: "black",
    strokeWidth: 0.5
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6695 101.575L86.0469 103.132",
    stroke: "black",
    strokeWidth: 0.5
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M86.047 103.132L86.9904 104.358",
    stroke: "black",
    strokeWidth: 0.5
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M100.434 104.358V101.434",
    stroke: "black",
    strokeWidth: 0.5
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M100.434 101.434L99.4431 98.6508",
    stroke: "black",
    strokeWidth: 0.5
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4903 108.651H112.603",
    stroke: "black",
    strokeWidth: 0.5
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2357 115.679L27.981 116.104",
    stroke: "black",
    strokeWidth: 0.5
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9811 116.104L25.9528 116.906",
    stroke: "black",
    strokeWidth: 0.5
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9528 116.905L24.066 117.66",
    stroke: "black",
    strokeWidth: 0.5
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M24.066 117.66V125.868",
    stroke: "black",
    strokeWidth: 0.5
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M24.066 125.868L23.3113 127",
    stroke: "black",
    strokeWidth: 0.5
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3113 127H11.5189",
    stroke: "black",
    strokeWidth: 0.5
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5189 127L10.2453 126.434",
    stroke: "black",
    strokeWidth: 0.5
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2453 126.434L9.86792 125.16",
    stroke: "black",
    strokeWidth: 0.5
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86792 125.16V108.651",
    stroke: "black",
    strokeWidth: 0.5
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86792 108.651L9.06604 102.755",
    stroke: "black",
    strokeWidth: 0.5
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06605 102.754L8.68869 96.7639",
    stroke: "black",
    strokeWidth: 0.5
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68871 96.7639L8.35852 91.4337",
    stroke: "black",
    strokeWidth: 0.5
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35851 91.4337L7.46228 86.1508",
    stroke: "black",
    strokeWidth: 0.5
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46228 86.1509L7.55662 84.1697",
    stroke: "black",
    strokeWidth: 0.5
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55658 84.1699L8.40564 82.3303",
    stroke: "black",
    strokeWidth: 0.5
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40567 82.33L11.6604 78.5093",
    stroke: "black",
    strokeWidth: 0.5
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6604 78.5095L10.1509 75.3962",
    stroke: "black",
    strokeWidth: 0.5
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M10.151 75.3962L6.28305 75.9623",
    stroke: "black",
    strokeWidth: 0.5
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28301 75.9621L2.55661 74.9716",
    stroke: "black",
    strokeWidth: 0.5
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5566 74.9717L1 73.2736",
    stroke: "black",
    strokeWidth: 0.5
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M1 73.2735V70.9623",
    stroke: "black",
    strokeWidth: 0.5
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M1 70.9624L2.60377 69.3115",
    stroke: "black",
    strokeWidth: 0.5
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60382 69.3113L6.94343 68.0378",
    stroke: "black",
    strokeWidth: 0.5
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94342 68.0378L11.4245 68.1321",
    stroke: "black",
    strokeWidth: 0.5
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4245 68.1322L13.1698 69.6887",
    stroke: "black",
    strokeWidth: 0.5
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1698 69.6886L13.3584 72.0471",
    stroke: "black",
    strokeWidth: 0.5
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3585 72.0471L13.2641 74.3113",
    stroke: "black",
    strokeWidth: 0.5
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2641 74.3112L13.9717 76.4338",
    stroke: "black",
    strokeWidth: 0.5
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9716 76.4338L15.1509 75.5376",
    stroke: "black",
    strokeWidth: 0.5
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1509 75.5378L19.3962 64.4056",
    stroke: "black",
    strokeWidth: 0.5
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3962 64.4055L24.5849 53.7452",
    stroke: "black",
    strokeWidth: 0.5
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5848 53.7454L26.7075 51.434",
    stroke: "black",
    strokeWidth: 0.5
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7075 51.434L29.4905 50.0662",
    stroke: "black",
    strokeWidth: 0.5
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4905 50.0661L45.2923 47.6132",
    stroke: "black",
    strokeWidth: 0.5
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2923 47.6132L61.2356 47",
    stroke: "black",
    strokeWidth: 0.5
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2357 47L77.2262 47.6132",
    stroke: "black",
    strokeWidth: 0.5
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2262 47.6132L92.9809 50.0661",
    stroke: "black",
    strokeWidth: 0.5
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9808 50.0662L95.7638 51.434",
    stroke: "black",
    strokeWidth: 0.5
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7639 51.434L97.8866 53.7454",
    stroke: "black",
    strokeWidth: 0.5
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8865 53.7452L103.075 64.4055",
    stroke: "black",
    strokeWidth: 0.5
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M103.075 64.4056L107.32 75.5378",
    stroke: "black",
    strokeWidth: 0.5
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M107.32 75.5376L108.5 76.4338",
    stroke: "black",
    strokeWidth: 0.5
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 76.4338L109.207 74.3112",
    stroke: "black",
    strokeWidth: 0.5
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M109.207 74.3113L109.113 72.0471",
    stroke: "black",
    strokeWidth: 0.5
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M109.113 72.0471L109.302 69.6886",
    stroke: "black",
    strokeWidth: 0.5
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M109.302 69.6887L111.047 68.1322",
    stroke: "black",
    strokeWidth: 0.5
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M111.047 68.1321L115.575 68.0378",
    stroke: "black",
    strokeWidth: 0.5
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M115.575 68.0378L119.868 69.3113",
    stroke: "black",
    strokeWidth: 0.5
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M119.868 69.3115L121.471 70.9624",
    stroke: "black",
    strokeWidth: 0.5
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M121.471 70.9623V73.2735",
    stroke: "black",
    strokeWidth: 0.5
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M121.471 73.2736L119.915 74.9717",
    stroke: "black",
    strokeWidth: 0.5
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M119.915 74.9716L116.188 75.9621",
    stroke: "black",
    strokeWidth: 0.5
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M116.188 75.9623L112.368 75.3962",
    stroke: "black",
    strokeWidth: 0.5
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M112.368 75.3962L110.858 78.5095",
    stroke: "black",
    strokeWidth: 0.5
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M110.858 78.5093L114.113 82.33",
    stroke: "black",
    strokeWidth: 0.5
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M114.113 82.3303L114.915 84.1699",
    stroke: "black",
    strokeWidth: 0.5
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M114.915 84.1697L115.009 86.1509",
    stroke: "black",
    strokeWidth: 0.5
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M115.009 86.1508L114.113 91.4337",
    stroke: "black",
    strokeWidth: 0.5
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M114.113 91.4337L113.783 96.7639",
    stroke: "black",
    strokeWidth: 0.5
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M113.783 96.7639L113.453 102.754",
    stroke: "black",
    strokeWidth: 0.5
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M113.453 102.755L112.603 108.651",
    stroke: "black",
    strokeWidth: 0.5
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M112.603 108.651V125.16",
    stroke: "black",
    strokeWidth: 0.5
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M112.603 125.16L112.226 126.434",
    stroke: "black",
    strokeWidth: 0.5
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M112.226 126.434L110.953 127",
    stroke: "black",
    strokeWidth: 0.5
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M110.953 127H99.1602",
    stroke: "black",
    strokeWidth: 0.5
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1601 127L98.4525 125.868",
    stroke: "black",
    strokeWidth: 0.5
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4525 125.868V117.66",
    stroke: "black",
    strokeWidth: 0.5
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4525 117.66L96.5186 116.905",
    stroke: "black",
    strokeWidth: 0.5
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5186 116.906L94.4903 116.104",
    stroke: "black",
    strokeWidth: 0.5
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4903 116.104L61.2357 115.679",
    stroke: "black",
    strokeWidth: 0.5
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64154 95.0187H23.5943",
    stroke: "black",
    strokeWidth: 0.5
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5943 95.0188L29.0188 94.8773",
    stroke: "black",
    strokeWidth: 0.5
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0188 94.8775L34.349 94.1227",
    stroke: "black",
    strokeWidth: 0.5
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M34.349 94.1226L35.1509 93.3679",
    stroke: "black",
    strokeWidth: 0.5
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1509 93.3678L35.7641 91.5754",
    stroke: "black",
    strokeWidth: 0.5
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7641 91.5752L35.5754 89.6885",
    stroke: "black",
    strokeWidth: 0.5
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5754 89.6886L32.9339 83.8395",
    stroke: "black",
    strokeWidth: 0.5
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9339 83.8396L28.9244 78.7926",
    stroke: "black",
    strokeWidth: 0.5
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9245 78.7923L23.8302 74.8771",
    stroke: "black",
    strokeWidth: 0.5
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8301 74.8773L20.6226 74.4528",
    stroke: "black",
    strokeWidth: 0.5
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6226 74.4528L15.1509 75.5377",
    stroke: "black",
    strokeWidth: 0.5
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0471 81.2454L21.8962 81.0566",
    stroke: "black",
    strokeWidth: 0.5
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8962 81.0566L17.8396 82.0473",
    stroke: "black",
    strokeWidth: 0.5
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8396 82.047L16.4245 83.0375",
    stroke: "black",
    strokeWidth: 0.5
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4245 83.0377L15.6226 84.5",
    stroke: "black",
    strokeWidth: 0.5
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6227 84.4999L15.2925 87.3301",
    stroke: "black",
    strokeWidth: 0.5
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2925 87.33L15.9529 90.113",
    stroke: "black",
    strokeWidth: 0.5
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9528 90.1132L17.6509 91.7169",
    stroke: "black",
    strokeWidth: 0.5
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M17.651 91.717L19.8208 92.6605",
    stroke: "black",
    strokeWidth: 0.5
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8207 92.6602L24.1131 93.3677",
    stroke: "black",
    strokeWidth: 0.5
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1132 93.3679L28.4056 92.4716",
    stroke: "black",
    strokeWidth: 0.5
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4056 92.4716L30.5754 90.9149",
    stroke: "black",
    strokeWidth: 0.5
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5754 90.9149L31.8962 88.5565",
    stroke: "black",
    strokeWidth: 0.5
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8961 88.5565L32.0848 87.1414",
    stroke: "black",
    strokeWidth: 0.5
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0848 87.1414L31.7546 85.7264",
    stroke: "black",
    strokeWidth: 0.5
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7547 85.7264L29.4434 82.8019",
    stroke: "black",
    strokeWidth: 0.5
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4434 82.8019L26.0471 81.2452",
    stroke: "black",
    strokeWidth: 0.5
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M29.349 84.5943L26.7075 82.6603",
    stroke: "black",
    strokeWidth: 0.5
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7075 82.6603L23.4528 82.0942",
    stroke: "black",
    strokeWidth: 0.5
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4528 82.0942L20.8112 82.566",
    stroke: "black",
    strokeWidth: 0.5
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8113 82.5658L18.2641 83.5563",
    stroke: "black",
    strokeWidth: 0.5
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2641 83.5565L16.9905 84.6415",
    stroke: "black",
    strokeWidth: 0.5
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9905 84.6416L16.283 86.1511",
    stroke: "black",
    strokeWidth: 0.5
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M16.283 86.1508L16.3773 88.179",
    stroke: "black",
    strokeWidth: 0.5
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3773 88.1793L17.2736 90.019",
    stroke: "black",
    strokeWidth: 0.5
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2735 90.019L18.8773 91.2453",
    stroke: "black",
    strokeWidth: 0.5
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8773 91.2452L22.3679 92.2829",
    stroke: "black",
    strokeWidth: 0.5
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3679 92.2829L26.0471 92.1886",
    stroke: "black",
    strokeWidth: 0.5
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0471 92.1886L28.5 91.0566",
    stroke: "black",
    strokeWidth: 0.5
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4999 91.0566L30.1509 88.9339",
    stroke: "black",
    strokeWidth: 0.5
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1509 88.9338L30.3867 86.6696",
    stroke: "black",
    strokeWidth: 0.5
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3868 86.6698L29.349 84.5944",
    stroke: "black",
    strokeWidth: 0.5
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4714 81.2454L100.622 81.0566",
    stroke: "black",
    strokeWidth: 0.5
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M100.622 81.0566L104.632 82.0473",
    stroke: "black",
    strokeWidth: 0.5
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M104.632 82.047L106.047 83.0375",
    stroke: "black",
    strokeWidth: 0.5
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M106.047 83.0377L106.896 84.5",
    stroke: "black",
    strokeWidth: 0.5
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M106.896 84.4999L107.179 87.3301",
    stroke: "black",
    strokeWidth: 0.5
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M107.179 87.33L106.519 90.113",
    stroke: "black",
    strokeWidth: 0.5
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M106.519 90.1132L104.82 91.7169",
    stroke: "black",
    strokeWidth: 0.5
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M104.82 91.717L102.651 92.6605",
    stroke: "black",
    strokeWidth: 0.5
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M102.651 92.6602L98.3582 93.3677",
    stroke: "black",
    strokeWidth: 0.5
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3582 93.3679L94.1129 92.4716",
    stroke: "black",
    strokeWidth: 0.5
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1129 92.4716L91.896 90.9149",
    stroke: "black",
    strokeWidth: 0.5
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M91.896 90.9149L90.5752 88.5565",
    stroke: "black",
    strokeWidth: 0.5
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5752 88.5565L90.4337 87.1414",
    stroke: "black",
    strokeWidth: 0.5
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4337 87.1414L90.7167 85.7264",
    stroke: "black",
    strokeWidth: 0.5
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7167 85.7264L93.0281 82.8019",
    stroke: "black",
    strokeWidth: 0.5
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0281 82.8019L96.4715 81.2452",
    stroke: "black",
    strokeWidth: 0.5
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1224 84.5943L95.8111 82.6603",
    stroke: "black",
    strokeWidth: 0.5
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8111 82.6603L99.0186 82.0942",
    stroke: "black",
    strokeWidth: 0.5
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0186 82.0942L101.707 82.566",
    stroke: "black",
    strokeWidth: 0.5
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M101.707 82.5658L104.207 83.5563",
    stroke: "black",
    strokeWidth: 0.5
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M104.207 83.5565L105.528 84.6415",
    stroke: "black",
    strokeWidth: 0.5
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M105.528 84.6416L106.188 86.1511",
    stroke: "black",
    strokeWidth: 0.5
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M106.188 86.1508L106.094 88.179",
    stroke: "black",
    strokeWidth: 0.5
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M106.094 88.1793L105.198 90.019",
    stroke: "black",
    strokeWidth: 0.5
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M105.198 90.019L103.594 91.2453",
    stroke: "black",
    strokeWidth: 0.5
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M103.594 91.2452L100.104 92.2829",
    stroke: "black",
    strokeWidth: 0.5
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M100.104 92.2829L96.4714 92.1886",
    stroke: "black",
    strokeWidth: 0.5
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4714 92.1886L94.0186 91.0566",
    stroke: "black",
    strokeWidth: 0.5
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0186 91.0566L92.3677 88.9339",
    stroke: "black",
    strokeWidth: 0.5
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3677 88.9338L92.0847 86.6696",
    stroke: "black",
    strokeWidth: 0.5
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0847 86.6698L93.1224 84.5944",
    stroke: "black",
    strokeWidth: 0.5
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M113.83 95.0187H98.8771",
    stroke: "black",
    strokeWidth: 0.5
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8771 95.0188L93.4997 94.8773",
    stroke: "black",
    strokeWidth: 0.5
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4997 94.8775L88.1696 94.1227",
    stroke: "black",
    strokeWidth: 0.5
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1696 94.1226L87.3205 93.3679",
    stroke: "black",
    strokeWidth: 0.5
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3205 93.3678L86.7545 91.5754",
    stroke: "black",
    strokeWidth: 0.5
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7545 91.5752L86.896 89.6885",
    stroke: "black",
    strokeWidth: 0.5
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M86.896 89.6886L89.5375 83.8395",
    stroke: "black",
    strokeWidth: 0.5
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5375 83.8396L93.5469 78.7926",
    stroke: "black",
    strokeWidth: 0.5
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5469 78.7923L98.6413 74.8771",
    stroke: "black",
    strokeWidth: 0.5
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6412 74.8773L101.849 74.4528",
    stroke: "black",
    strokeWidth: 0.5
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M101.849 74.4528L107.32 75.5377",
    stroke: "black",
    strokeWidth: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    width: 25,
    height: 28,
    rx: 2,
    fill: "#254292"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9375 21V6.45455H63.2159C64.2955 6.45455 65.2401 6.66761 66.0497 7.09375C66.8594 7.51989 67.4891 8.11884 67.9389 8.89062C68.3887 9.66241 68.6136 10.5644 68.6136 11.5966C68.6136 12.6383 68.3816 13.5402 67.9176 14.3026C67.4583 15.0649 66.812 15.652 65.9787 16.0639C65.1501 16.4759 64.1818 16.6818 63.0739 16.6818H59.3239V13.6136H62.2784C62.7424 13.6136 63.1378 13.5331 63.4645 13.3722C63.7959 13.2064 64.0492 12.9721 64.2244 12.669C64.4044 12.366 64.4943 12.0085 64.4943 11.5966C64.4943 11.1799 64.4044 10.8248 64.2244 10.5312C64.0492 10.233 63.7959 10.0057 63.4645 9.84943C63.1378 9.68845 62.7424 9.60795 62.2784 9.60795H60.8864V21H56.9375Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCarFrontParked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/carFrontParked.ed8c5b754ccd92407dda050a4f8e079c.svg";